import { t } from 'i18next'

import type { CompradorPessoaFisicaStepSchemaInput } from '@/features/proposta/schemas/compradores/comprador-pf.schema'
import { EstadoCivilEnum } from '@/types/cliente'
import { ClienteRegimeCasamentoEnum, type TClienteRegimeCasamentoEnum } from '@/types/proposta'

export type Issue = { message: string; path: string[] }
export class EstadoCivilCompradorPrincipalValidator {
  constructor(private readonly params: CompradorPessoaFisicaStepSchemaInput['estadoCivil']) {}
  private estadoCivilIssue(): Issue {
    return {
      message: t('proposta:cadastro_compradores.steps.estado_civil.erro.estado_civil'),
      path: ['estadoCivil', 'status'],
    }
  }
  private uniaoEstavelIssue(): Issue {
    return {
      message: t('proposta:cadastro_compradores.steps.estado_civil.erro.uniao_estavel'),
      path: ['estadoCivil', 'uniaoEstavel'],
    }
  }
  private regimeCasamentoIssue(): Issue {
    return {
      message: t('proposta:cadastro_compradores.steps.estado_civil.erro.regime_casamento'),
      path: ['estadoCivil', 'regimeCasamento'],
    }
  }
  private tipoAssinaturaIssue(): Issue {
    return {
      message: t('proposta:cadastro_compradores.steps.estado_civil.erro.tipo_assinatura'),
      path: ['estadoCivil', 'tipoAssinatura'],
    }
  }

  run(): Issue | null {
    if (!this.params) return null
    const { status, uniaoEstavel, regimeCasamento, tipoAssinatura } = this.params
    if (!status) return this.estadoCivilIssue()
    if (status !== EstadoCivilEnum.CivilCasado) return uniaoEstavel ? null : this.uniaoEstavelIssue()
    if (!regimeCasamento) return this.regimeCasamentoIssue()
    const regimesDeCasamentoQueExigemAssinatura = [
      ClienteRegimeCasamentoEnum.ComunhaoUniversalBens,
      ClienteRegimeCasamentoEnum.ComunhaoParcialBens,
      ClienteRegimeCasamentoEnum.ParticipacaoFinalNosAquestos,
    ]
    const exigeAssinatura = regimesDeCasamentoQueExigemAssinatura.includes(
      regimeCasamento as Exclude<
        TClienteRegimeCasamentoEnum,
        'SeparacaoLegal' | 'SeparacaoTotalBens' | 'SeparacaoObrigatoriaBens' | 'SeparacaoConvencional'
      >,
    )
    if (exigeAssinatura && !tipoAssinatura) return this.tipoAssinaturaIssue()
    return null
  }
}
